import type { StylisPlugin } from '@emotion/cache';

const getAdaptedRemValue = require('@unifyapps/style/helpers/getAdaptedRemValue.cjs');

// Stylis plugin which checks all style declarations and changes all rem values to adapted rem values with remMultiplier support
export const stylisRemMultiplier: StylisPlugin = (node) => {
  if (node.type === 'decl') {
    if (node.value.indexOf('rem') === -1) return;
    const updatedValue = getAdaptedRemValue(node.children);
    node.return = node.props + ':' + updatedValue + ';';
  }
};
